import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function MiguelAndrade() {
  return (
    <AdvisorProvider advisor={advisors["miguel-andrade"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}